import {
  AfterViewInit,
  Component,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainHeadingComponent } from '../../atoms/main-heading/main-heading.component';
import { Store } from '../../../types';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { StoreService } from '../../../services/store/store.service';
import { BehaviorSubject, firstValueFrom, Observable, of } from 'rxjs';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import {
  MemberLookupResult,
  MemberLookupService,
} from '../../../services/member-lookup/member-lookup.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MainHeadingSubtextComponent } from '../../atoms/main-heading-subtext/main-heading-subtext.component';
import { DateFnsModule } from 'ngx-date-fns';

@Component({
  selector: 'app-member-lookup-page',
  standalone: true,
  templateUrl: './member-lookup-page.component.html',
  styleUrls: ['./member-lookup-page.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    MainHeadingComponent,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    DateFnsModule,
  ],
})
export class MemberLookupPageComponent implements OnInit, AfterViewInit {
  constructor(private memberLookupService: MemberLookupService) {}

  public email: string = '';

  public lookupResult$: BehaviorSubject<MemberLookupResult | null> =
    new BehaviorSubject<MemberLookupResult | null>(null);

  public loading = false;

  async ngOnInit() {}

  ngAfterViewInit() {}

  async lookupMember() {
    if (this.email) {
      this.loading = true;
      this.lookupResult$.next(null);
      const result = await firstValueFrom(
        this.memberLookupService.lookupMember(this.email)
      );
      this.loading = false;
      this.lookupResult$.next(result);
    }
  }
}
